import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Native sponsored card mixed into the PDF Books & More grid.
 * Looks like a book card but is clearly marked "Sponsored".
 */
const SponsoredBookCard = () => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/api/ads/active`)
      .then((res) => {
        if (cancelled) return;
        const list = (res.data && res.data.books_sponsored) || [];
        if (list.length > 0) setAd(list[0]);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ad) return null;

  return (
    <a
      href={ad.destination_url || '#'}
      target="_blank"
      rel="noopener sponsored noreferrer"
      data-testid="sponsored-book-card"
      className="group relative bg-[#1A1A1A] rounded-lg overflow-hidden border border-[#262626] hover:border-[#D4AF37]/50 transition-all"
      aria-label={`Sponsored: ${ad.brand_name}`}
    >
      <span className="absolute top-2 right-2 z-10 text-[9px] tracking-[0.2em] uppercase text-black bg-[#D4AF37] px-2 py-0.5 rounded font-medium">
        Sponsored
      </span>
      {ad.ad_image_url ? (
        <img
          src={ad.ad_image_url}
          alt={ad.brand_name}
          className="w-full aspect-[3/4] object-cover"
        />
      ) : (
        <div className="w-full aspect-[3/4] bg-gradient-to-br from-[#0A2216] to-[#1A1A1A] flex items-center justify-center">
          <span className="text-xl text-[#D4AF37] font-['Bebas_Neue'] text-center px-4">
            {ad.brand_name}
          </span>
        </div>
      )}
      <div className="p-4">
        <p className="text-sm text-[#A3A3A3] uppercase tracking-wider">{ad.brand_name}</p>
        {ad.headline && <p className="text-white font-medium mt-1 truncate">{ad.headline}</p>}
        {ad.short_description && <p className="text-xs text-[#A3A3A3] mt-1 line-clamp-2">{ad.short_description}</p>}
        <p className="text-xs text-[#D4AF37] mt-2 group-hover:underline">
          {ad.cta_text || 'Learn more'} &rarr;
        </p>
      </div>
    </a>
  );
};

export default SponsoredBookCard;
